import en from './posAdmin.en.json';
import de from './posAdmin.de.json';
import pl from './posAdmin.pl.json';

// Static, bundled UI strings only. Never translate guest/staff names or send text externally.
export const posAdminResources = { en: en.ui, de: de.ui, pl: pl.ui };
export const posAdminAdditions = { en: en.additions, de: de.additions, pl: pl.additions };
